export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-1-break.06700e59.webp";